<template>
  <div class="pa-10">
    <AssignRoleDataTable />
  </div>
</template>

<script>
import AssignRoleDataTable from "@/components/Utils/AssignRoleDataTable.vue";

export default {
  components: {
    AssignRoleDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
